// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__3vF1I","checkboxCol":"Table_checkboxCol__3Wo9f","emailCol":"Table_emailCol__2CQOH","actionCol":"Table_actionCol__3EBnb"};